import { createSelector } from '@reduxjs/toolkit';

import { getClassHierarchy } from 'src/containers/ProjectDiagram/utils/getClassHierarchy';
import { projectClassIrisSelector } from 'src/selectors/projectClassIris';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';

export const projectClassHierarchySelector = (projectId: string) =>
  createSelector(
    projectLinkDataArraySelector(projectId),
    projectClassIrisSelector(projectId),
    getClassHierarchy
  );
